import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../../assets/img/pdf_icon_version4.png'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = {
  key: 0,
  class: "empty-state-box text-center p-5 mt-4 rounded border shadow-sm"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_5 = { class: "d-flex flex-column flex-md-row justify-content-md-between align-items-md-center border-bottom pb-3 mb-3 gap-3" }
const _hoisted_6 = { class: "group-info-card mini w-100 w-md-auto" }
const _hoisted_7 = { class: "group-details" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = { class: "value fw-bold text-capitalize-first" }
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = { class: "value text-capitalize-first" }
const _hoisted_12 = { class: "info-row align-center mb-3 mt-md-0" }
const _hoisted_13 = { class: "value text-capitalize-first" }
const _hoisted_14 = {
  key: 0,
  class: "status-dot orange"
}
const _hoisted_15 = {
  key: 1,
  class: "status-dot green"
}
const _hoisted_16 = {
  key: 2,
  class: "status-dot red"
}
const _hoisted_17 = { class: "d-flex flex-column flex-sm-row flex-md-row align-items-start align-items-sm-center align-items-md-center gap-2 gap-md-3" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "col-12 col-lg-6 mb-3 mb-lg-0 text-start" }
const _hoisted_22 = { class: "d-inline-flex flex-wrap align-items-center" }
const _hoisted_23 = { class: "mb-1 mb-sm-0 fw-bold text-capitalize text-dark me-2" }
const _hoisted_24 = {
  key: 0,
  class: "badge text-bg-danger text-white fw-bold p-1 my-1 my-sm-0",
  style: {"font-size":"10px","letter-spacing":"0.3px","white-space":"nowrap"}
}
const _hoisted_25 = { class: "col-12 col-lg-6" }
const _hoisted_26 = { class: "d-flex flex-column flex-sm-row justify-content-lg-end align-items-stretch align-items-sm-center w-100" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]

import unemployedService from '@/api/Unemployed';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import Form from './Form.vue';
import UnemployedDetails from '@/views/App/Unemployed/UnemployedDetails.vue';
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {downloadFile} from "@/shared/functions";
import DigitalSignatureForm from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/DigitalSignatureForm.vue";
import DocumentMenu from "@/views/App/Unemployed/DigitalDocuments/DocumentMenu.vue";
import FurtherTrainingForm from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/FurtherTrainingForm.vue";
import HealthQuestionnaireForm
  from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/HealthQuestionnaireForm.vue";
import SelectionInterviewForm from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/SelectionInterviewForm.vue";
import AssignCoachingForm from "@/views/App/Unemployed/DigitalDocuments/PrivateCoaching/AssignCoachingForm.vue";


export interface DocumentGroup {
  uuid: string;
  groupTitle: string;
  allDocumentSigned: boolean;
  coachingId: number|null;
  coachingDateRange: string;
  coachingStatusTranslation: string;
  coachingStatus: string;
  documents: DocumentItem[];
}

export interface DocumentItem {
  id: number;
  title: string;
  type: string;
  isSigned: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const {t} = useI18n();
const route = useRoute();
const unemployedId = +(route.params.id || 0);
const unemployed = ref<any>(null);
const documentCounts = ref<any>(null);
const documentGroups = ref<DocumentGroup[]>([]);
const isLoaded = ref(false);
const submitForm = ref(false);
const selectedGroupUuid = ref('');
const selectedGroupTitle = ref('');
const selectedDocumentId = ref();
const selectedCoachingId = ref()

const showModalForm = ref(false);
const showDeleteModal = ref(false);
const showDigitalSignatureModal = ref(false);
const showSelectionInterviewModal = ref(false);
const showFurtherTrainingModal = ref(false);
const showHealthQuestionnaireModal = ref(false);
const showAssignedCoachingModal = ref(false);

watch(submitForm, () => {
  selectedGroupUuid.value = '';
  selectedGroupTitle.value = '';
  closeAllModals()
  getDocumentGroups()
});

async function getUnemployedOverviewData() {
  try {
    const {data} = await unemployedService.getUnemployedOverview(unemployedId);
    unemployed.value = data.data.unemployed;
    documentCounts.value = data.data.documentCounts;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getDocumentGroups() {
  try {
    const {data} = await unemployedPrivateCoachingService.getDigitalDocuments(unemployedId);
    documentGroups.value = data.data;
  } catch (error) {
    await ErrorToast(error);
    documentGroups.value = [];
  }
}

function handleModalForm() {
  CloseToast();
  closeAllModals()
  showModalForm.value = true;
}

function handleAssignedCoachingModalForm(documentGroupUuid: string, coachingId: number|null) {
  CloseToast();
  closeAllModals()
  showAssignedCoachingModal.value = true;
  selectedGroupUuid.value = documentGroupUuid;
  selectedCoachingId.value = coachingId;
}

function handleModalEditForm(documentGroupId: string, documentGroupTitle: string) {
  CloseToast();
  closeAllModals()
  showModalForm.value = true;
  selectedGroupUuid.value = documentGroupId;
  selectedGroupTitle.value = documentGroupTitle;
}

function handleDeleteDocuments(documentGroupId: string) {
  CloseToast();
  closeAllModals()
  showDeleteModal.value = true;
  selectedGroupUuid.value = documentGroupId;
}

function handleDigitalSignatureModal(documentId: number) {
  CloseToast();
  closeAllModals()
  showDigitalSignatureModal.value = true
  selectedDocumentId.value = documentId;
}

function handleSelectionInterviewModal(documentId: number) {
  CloseToast();
  closeAllModals()
  showSelectionInterviewModal.value = true;
  selectedDocumentId.value = documentId;
}

function handleQuestionnaireModal(documentId: number) {
  CloseToast();
  closeAllModals()
  showHealthQuestionnaireModal.value = true;
  selectedDocumentId.value = documentId;
}

function handleTrainingContractModal(documentId: number) {
  CloseToast();
  closeAllModals()
  showFurtherTrainingModal.value = true
  selectedDocumentId.value = documentId;
}

function closeAllModals() {
  selectedGroupUuid.value = "";
  selectedGroupTitle.value = "";
  showModalForm.value = false;
  showDeleteModal.value = false;
  showDigitalSignatureModal.value = false;
  showSelectionInterviewModal.value = false;
  showFurtherTrainingModal.value = false;
  showHealthQuestionnaireModal.value = false;
  showAssignedCoachingModal.value = false;
}

async function deleteDocumentGroup() {
  try {
    await unemployedPrivateCoachingService.deleteDigitalDocuments(selectedGroupUuid.value);
    SuccessToast(t('general.toasts.delete_success'));
    showDeleteModal.value = false
    await getDocumentGroups();
  } catch (error) {
    await ErrorToast(error);
  }
}

function showFormButton(documentType: string): boolean {
  return [
    'selection_interview',
    'further_training_contract',
    'health_questionnaire'
  ].includes(documentType);
}

const modalHandlers: Record<string, (id: number) => void> = {
  selection_interview: handleSelectionInterviewModal,
  health_questionnaire: handleQuestionnaireModal,
  further_training_contract: handleTrainingContractModal,
};

function openForm(documentId: number, documentType: string) {
  const handler = modalHandlers[documentType];

  if (!handler) {
    ErrorToast(`No modal handler for type: ${documentType}`);
    return;
  }

  handler(documentId);
}

function getPdfUrl(type: string, groupUuid: string) {
  const mappedType = type.replaceAll('_', '-');
  return `/unemployed/private-coaching/digital-documents/${mappedType}-pdf/${groupUuid}`;
}

onMounted(async () => {
  CloseToast();

  await Promise.all([
    getUnemployedOverviewData(),
    getDocumentGroups(),
  ]);

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "element-header" }, "Kundendetails", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(UnemployedDetails, { unemployed: unemployed.value }, null, 8, ["unemployed"]),
              _createVNode(DocumentMenu, {
                unemployed: unemployed.value,
                documentCounts: documentCounts.value
              }, null, 8, ["unemployed", "documentCounts"]),
              _createElementVNode("div", {
                class: "row mb-2 mt-5",
                style: {"padding":"0"}
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-lg-6" }, [
                  _createElementVNode("h6", null, "Digitale Dokumente")
                ], -1)),
                _createElementVNode("div", { class: "col-lg-6 text-end" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary mb-2 me-2",
                    style: {"padding":"5px 7px"},
                    onClick: handleModalForm
                  }, " Neue Dokumentengruppe anlegen ")
                ])
              ]),
              (documentGroups.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("div", { class: "empty-state-icon mb-3" }, [
                      _createElementVNode("i", { class: "fa-solid fa-folder-open text-muted" })
                    ], -1),
                    _createElementVNode("h6", { class: "fw-bold text-dark mb-1" }, "Keine Dokumentengruppen vorhanden", -1),
                    _createElementVNode("p", { class: "text-muted small mb-0" }, "Bitte erstellen Sie eine neue Gruppe, um Dokumente zu verwalten.", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentGroups.value, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.uuid,
                        class: "mb-4 p-3 border rounded bg-white shadow-sm"
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "Gruppentitel:", -1)),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(group.groupTitle), 1)
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "Maßnahmen:", -1)),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(group.coachingDateRange), 1)
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "Status:", -1)),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(group.coachingStatusTranslation), 1),
                                (group.coachingStatus === 'new')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                                  : _createCommentVNode("", true),
                                (group.coachingStatus === 'active')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                                  : _createCommentVNode("", true),
                                (group.coachingStatus === 'finished')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (group.allDocumentSigned)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: ($event: any) => (handleAssignedCoachingModalForm(group.uuid, group.coachingId)),
                                  class: "btn btn-link text-primary fw-bold p-0 ms-1 mt-2 text-decoration-none small d-flex align-items-center",
                                  style: {"font-size":"14px"}
                                }, [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("i", { class: "fa fa-tasks me-1" }, null, -1),
                                  _createTextVNode(" Zugewiesene Maßnahmen ", -1)
                                ]))], 8, _hoisted_18))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (handleModalEditForm(group.uuid, group.groupTitle)),
                              class: "btn btn-link text-primary fw-bold p-0 ms-1 ms-md-2 mt-2 text-decoration-none small d-flex align-items-center",
                              style: {"font-size":"14px"}
                            }, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "fa fa-edit me-1" }, null, -1),
                              _createTextVNode(" Gruppentitel ändern ", -1)
                            ]))], 8, _hoisted_19),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (handleDeleteDocuments(group.uuid)),
                              class: "btn btn-link text-danger fw-bold p-0 ms-1 ms-md-2 mt-2 text-decoration-none small d-flex align-items-center",
                              style: {"font-size":"14px"}
                            }, [...(_cache[20] || (_cache[20] = [
                              _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                              _createTextVNode(" Löschen ", -1)
                            ]))], 8, _hoisted_20)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.documents, (doc, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: doc.id,
                            class: _normalizeClass(["row align-items-center py-3 py-md-2 mt-3 mt-md-4 mt-lg-0", {'border-bottom': index !== group.documents.length - 1}])
                          }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("h6", _hoisted_23, _toDisplayString(doc.title), 1),
                                (!doc.isSigned)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [...(_cache[21] || (_cache[21] = [
                                      _createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }, null, -1),
                                      _createTextVNode(" Fehlende digitale Signatur ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_unref(downloadFile)(getPdfUrl(doc.type, group.uuid), undefined)),
                                  class: "btn btn-light border fw-bold px-3 py-2 py-sm-1 mb-2 mb-sm-0 me-sm-2 d-flex align-items-center justify-content-center btn-sm",
                                  title: "Preuzmi PDF"
                                }, [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: "PDF",
                                    style: {"width":"16px","height":"auto"},
                                    class: "me-1"
                                  }, null, -1),
                                  _createElementVNode("span", { style: {"font-size":"12px"} }, "PDF", -1)
                                ]))], 8, _hoisted_27),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (handleDigitalSignatureModal(doc.id)),
                                  class: "btn btn-primary fw-bold px-3 py-2 py-sm-1 mb-2 mb-sm-0 me-sm-2 ms-0 ms-md-2 d-flex align-items-center justify-content-center btn-sm",
                                  style: {"font-size":"14px"}
                                }, [...(_cache[23] || (_cache[23] = [
                                  _createElementVNode("i", { class: "fa fa-pencil-alt me-1" }, null, -1),
                                  _createTextVNode(" Digitale Unterschrift ", -1)
                                ]))], 8, _hoisted_28),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (openForm(doc.id, doc.type)),
                                  class: _normalizeClass(["btn btn-outline-primary fw-bold px-3 py-2 py-sm-1 ms-0 ms-md-2 d-flex align-items-center justify-content-center btn-sm", [showFormButton(doc.type) ? 'd-flex' : 'invisible d-none d-sm-flex']]),
                                  style: {"font-size":"14px"}
                                }, [...(_cache[24] || (_cache[24] = [
                                  _createElementVNode("i", { class: "fa fa-file-alt me-1" }, null, -1),
                                  _createTextVNode(" Formular öffnen ", -1)
                                ]))], 10, _hoisted_29)
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    }), 128))
                  ]))
            ]),
            _createVNode(Modal, {
              modelValue: showModalForm.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModalForm).value = $event)),
              title: "Einführungsdokumente - Neue Gruppe",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              customWidth: '900px',
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(Form, {
                  documentGroupUuid: selectedGroupUuid.value,
                  unemployedId: unemployed.value?.id,
                  selectedGroupId: selectedGroupUuid.value,
                  selectedGroupTitle: selectedGroupTitle.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[0] || (_cache[0] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentGroupUuid", "unemployedId", "selectedGroupId", "selectedGroupTitle", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(Modal, {
              modelValue: showAssignedCoachingModal.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showAssignedCoachingModal).value = $event)),
              title: "Weisen Sie den digitalen Dokumenten Maßnahmen zu",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              customWidth: '600px',
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(AssignCoachingForm, {
                  documentGroupUuid: selectedGroupUuid.value,
                  unemployedId: unemployed.value?.id,
                  selectedCoachingId: selectedCoachingId.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[2] || (_cache[2] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentGroupUuid", "unemployedId", "selectedCoachingId", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(Modal, {
              modelValue: showDigitalSignatureModal.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDigitalSignatureModal).value = $event)),
              title: "Digitale Unterschrift",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-md",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(DigitalSignatureForm, {
                  documentId: selectedDocumentId.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[4] || (_cache[4] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentId", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(Modal, {
              modelValue: showSelectionInterviewModal.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showSelectionInterviewModal).value = $event)),
              title: "Auswahlgespräch",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-xl",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectionInterviewForm, {
                  documentId: selectedDocumentId.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[6] || (_cache[6] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentId", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(Modal, {
              modelValue: showFurtherTrainingModal.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showFurtherTrainingModal).value = $event)),
              title: "Weiterbildungsvertrag",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-xl",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(FurtherTrainingForm, {
                  documentId: selectedDocumentId.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[8] || (_cache[8] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentId", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(Modal, {
              modelValue: showHealthQuestionnaireModal.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showHealthQuestionnaireModal).value = $event)),
              title: "Gesundheitsfragebogen",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-xl",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(HealthQuestionnaireForm, {
                  documentId: selectedDocumentId.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[10] || (_cache[10] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["documentId", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"]),
            _createVNode(ModalDelete, {
              modelValue: showDeleteModal.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showDeleteModal).value = $event)),
              header: _unref(t)('general.delete_item_header'),
              onDelete: deleteDocumentGroup
            }, null, 8, ["modelValue", "header"])
          ]))
    ]),
    _: 1
  }))
}
}

})